import React from 'react';
import SignUpModal from '../../components/modals/SignUp/SignUp';

// Voycalc
import voycalcImage from '../../assets/voycalc.png';
import recentImage from '../../assets/recent.png';
import intakeImage from '../../assets/intake.png';
import routingImage from '../../assets/routing.png';

// Configuration
import xpdImage from '../../assets/dynamic-xpd.png';
import miscImage from '../../assets/dynamic-misc.png';
import seaConsumptionImage from '../../assets/seaconsumption-series.png';
import ecaConsumptionImage from '../../assets/eca-consumption.png';
import bunkerImage from '../../assets/bunker-in-port.png';
import canalCostImage from '../../assets/canal-cost.png';
import emissionsImage from '../../assets/emissions-factor.png';
import bunkerDefinitionsImage from '../../assets/bunker-definitions.png';

import changeImage from '../../assets/change.png';
import canalImage from '../../assets/canal.png';
import distanceImage from '../../assets/distance.png';
import ecaImage from '../../assets/eca.png';
import hraImage from '../../assets/hra.png';
import optimiseImage from '../../assets/optimise.png';

const Product: React.FC = () => {
  return (
    <>
      {/* Hero Section */}
      <section className="product-hero">
        <div className="product-hero-content">
          <h1 className="product-hero-title">
            The <span className="hero-highlight">Product</span>
          </h1>
          <p className="product-hero-subtitle">
            A simple and efficient calculator for your voyages. We're constantly building new features — try it yourself for the full experience!
          </p>
        </div>
      </section>

      {/* Features Section */}
      <section className="product-section">
        <div className="product-container">

          <div className="product-feature">
            <div className="product-feature-image">
              <img src={voycalcImage} alt="Voycalc" />
            </div>
            <div className="product-feature-content">
              <h3>The VoyCalc</h3>
              <p>
                An advanced estimator with Built-in efficiency features!
              </p>
            </div>
          </div>

          <div className="product-feature product-feature-reverse">
            <div className="product-feature-image">
              <img src={optimiseImage} alt="Options" />
            </div>
            <div className="product-feature-content">
              <h3>The VoyCalc Options</h3>
              <p>
                By a click-of-a-button, you can explore and compare alternative options for your calc! Add multiple vessels from your own vessel list, or simply copy the estimate and explore impact by playing with the intake?
              </p>
            </div>
          </div>

          <div className="product-feature">
            <div className="product-feature-image">
              <img src={recentImage} alt="Voycalc" />
            </div>
            <div className="product-feature-content">
              <h3>Your Recent Estimates</h3>
              <p>
                We know how you like easy access to your recent estimates! In Voycalc, you can always reach them, by a click-of-a-button!
              </p>
            </div>
          </div>

          <div className="product-feature product-feature-reverse">
            <div className="product-feature-image">
              <img src={intakeImage} alt="Voycalc" />
            </div>
            <div className="product-feature-content">
              <h3>Simple Intake Calculator</h3>
              <p>
                Just a simple intake calc... 
              </p>
            </div>
          </div>

          <div className="product-feature">
            <div className="product-feature-image">
              <img src={routingImage} alt="Voycalc" />
            </div>
            <div className="product-feature-content">
              <h3>Routing</h3>
              <p>
                Test routing options, and immediately see the impact!
              </p>
            </div>
          </div>


          {/* Explore */}
          <div className="product-feature product-feature-reverse">
            <div className="product-feature-image">
              <img src={changeImage} alt="Explore Changes" />
            </div>
            <div className="product-feature-content">
              <h3>Explore</h3>
              <p>
                When you make changes, you'll instantly see the impact! If you don't like it, refresh and you're back to where you started — or save it and it becomes your new baseline.
              </p>
            </div>
          </div>

          {/* Divider */}
          <div className="product-divider">
            <p>We are NOT a VMS — We simply focus on the VoyCalc!</p>
          </div>

          {/* Distance Table */}
          <div className="product-feature">
            <div className="product-feature-image">
              <img src={distanceImage} alt="Distance Table" />
            </div>
            <div className="product-feature-content">
              <h3>Distance Table</h3>
              <p>
                Of course we have a distance table! We have thousands of ports, and if we're missing one, just let us know and we'll quickly add it for you!
              </p>
            </div>
          </div>

          {/* Routing Options */}
          <div className="product-feature product-feature-reverse">
            <div className="product-feature-image">
              <img src={optimiseImage} alt="Routing Options" />
            </div>
            <div className="product-feature-content">
              <h3>Routing Options</h3>
              <p>
                Enable and disable route options and choose to optimise to minimise ECA or HRA exposure.
              </p>
            </div>
          </div>

          {/* Divider */}
          <div className="product-divider">
            <p>Thousands of ports and tens of thousands of routing waypoints!</p>
          </div>

          {/* Canals */}
          <div className="product-feature">
            <div className="product-feature-image">
              <img src={canalImage} alt="Canals/Straits/Rivers" />
            </div>
            <div className="product-feature-content">
              <h3>Canals, Straits & Rivers</h3>
              <p>
                We've created the common ones to give you options when doing your calcs. Let us know if we missed one!
              </p>
            </div>
          </div>

          {/* HRA */}
          <div className="product-feature product-feature-reverse">
            <div className="product-feature-image">
              <img src={hraImage} alt="HRA Areas" />
            </div>
            <div className="product-feature-content">
              <h3>HRA Areas</h3>
              <p>
                Does your legal or risk team need early alerts about voyages entering HRA? We can automatically trigger an event when you fix it, alerting them so they can handle the insurance.
              </p>
            </div>
          </div>

          {/* ECA */}
          <div className="product-feature">
            <div className="product-feature-image">
              <img src={ecaImage} alt="ECA Areas" />
            </div>
            <div className="product-feature-content">
              <h3>ECA Areas</h3>
              <p>
                Our tool makes it easy to add new ECA areas. You'll be ready for 2027, and you would have had no problems with the Med zone in May '25...
              </p>
            </div>
          </div>

          {/* Divider */}
          <div className="product-divider">
            <p>Configurations and flexibility is key!</p>
          </div>

          <div className="product-feature">
            <div className="product-feature-image">
              <img src={xpdImage} alt="Configuration" />
            </div>
            <div className="product-feature-content">
              <h3>Flexible XPD list</h3>
              <p>
                Add the fields you want to use for your Xtra Port Days calculations!
              </p>
            </div>
          </div>

          <div className="product-feature product-feature-reverse">
            <div className="product-feature-image">
              <img src={miscImage} alt="Configuration" />
            </div>
            <div className="product-feature-content">
              <h3>Flexible MISC list</h3>
              <p>
                Choose your defaults!
              </p>
            </div>
          </div>

          <div className="product-feature">
            <div className="product-feature-image">
              <img src={seaConsumptionImage} alt="Configuration" />
            </div>
            <div className="product-feature-content">
              <h3>Sea Consumption</h3>
              <p>
                Since we expect bunker types to change, we made our vessel engine more flexible. We specify consumption, and not bunker types on vessel level, which will give you a lot of flexibility moving forward. You may also have multiple series of consumption, allowing you to play with warranted and expected consumption. This is critical if you have better data on vessel consumption, than the market!
              </p>
            </div>
          </div>

          <div className="product-feature product-feature-reverse">
            <div className="product-feature-image">
              <img src={ecaConsumptionImage} alt="Configuration" />
            </div>
            <div className="product-feature-content">
              <h3>ECA Consumption</h3>
              <p>
                Advanced consumption matrix for eca zones. Most importantly, you can plan for it and add changes that will only apply in the future. Did you loose money 1th of May 2025 when Med was made active?
              </p>
            </div>
          </div>

          <div className="product-feature">
            <div className="product-feature-image">
              <img src={bunkerImage} alt="Configuration" />
            </div>
            <div className="product-feature-content">
              <h3>Bunker in Port</h3>
              <p>
                Advanced features for defining bunker consumptions in ports!
              </p>
            </div>
          </div>

          <div className="product-feature product-feature-reverse">
            <div className="product-feature-image">
              <img src={canalCostImage} alt="Configuration" />
            </div>
            <div className="product-feature-content">
              <h3>Canal Cost</h3>
              <p>
                Cost Matrix that enable you to specify both current and future cost changes for canals based on vessel size!
              </p>
            </div>
          </div>

          <div className="product-feature">
            <div className="product-feature-image">
              <img src={emissionsImage} alt="Configuration" />
            </div>
            <div className="product-feature-content">
              <h3>Emission Factors</h3>
              <p>
                You can specify which factors you want to use.
              </p>
            </div>
          </div>

          <div className="product-feature product-feature-reverse">
            <div className="product-feature-image">
              <img src={bunkerDefinitionsImage} alt="Configuration" />
            </div>
            <div className="product-feature-content">
              <h3>Bunker Definitions</h3>
              <p>
                Specify the bunker types you want to use with emission factors.
              </p>
            </div>
          </div>




          {/* Core Product Cards */}
          <div className="product-cards">
            <div className="product-card">
              <div className="product-card-icon">
                <i className="bi bi-calculator"></i>
              </div>
              <h3>The VoyCalc Module</h3>
              <p>
                While you can get the work done on a napkin, the VoyCalc does most of the job for you! It remembers your preferences, and your insights. It has never been easier and faster to create a calc!
              </p>
            </div>
            <div className="product-card">
              <div className="product-card-icon">
                <i className="bi bi-building"></i>
              </div>
              <h3>Enterprise Model</h3>
              <p>
                While we offer single user subscriptions, we also offer single tenant enterprise solutions with Single Sign-On options. Contact us for details! This is needed if you want shared vessel list and shared voycalcs.
              </p>
            </div>
          </div>

          {/* CTA */}
          <div className="product-cta">
            <p className="product-cta-text">
              Ready to try VoyCalc?
            </p>
            <SignUpModal showSubtext={false} />
          </div>

        </div>
      </section>
    </>
  );
};

export default Product;
